import tracker from './tracker';

export function eventHandler(eventDefinition, payload) {
  const eventPayload = eventDefinition.payloadTransformer(payload);


  if (eventDefinition.callbackFn) {
    eventDefinition.callbackFn(eventPayload);
  }

  tracker.trackBabbelTracker(
    eventDefinition.trackerEventName,
    eventDefinition.trackerEventVersion,
    Object.assign({}, eventPayload, eventDefinition.getAdditionalInformation())
  );
}

export class Observer {
  constructor(subject, handler) {
    this.subject = subject;
    this.handler = handler;
  }

  observe() {
    Object.keys(this.handler).forEach((eventName) => {
      const eventDefinition = this.handler[eventName];
      // TODO: Look into how to test bound functions. Or simplify the line below.
      eventDefinition.eventHandler = eventHandler.bind(null, eventDefinition);
      this.subject.on(eventName, eventDefinition.eventHandler);
    });
  }

  unobserve() {
    Object.keys(this.handler).forEach((eventName) => {
      const eventDefinition = this.handler[eventName];
      if (eventDefinition.eventHandler) {
        this.subject.removeListener(eventName, eventDefinition.eventHandler);
        delete eventDefinition.eventHandler;
      }
    });
  }
}
